'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const defaultKeyMap = [
    {
        name: 'MouseLeft',
        pointerType: 'mouse',
        button: 'primary'
    },
    {
        name: 'MouseRight',
        pointerType: 'mouse',
        button: 'secondary'
    },
    {
        name: 'MouseMiddle',
        pointerType: 'mouse',
        button: 'auxiliary'
    },
    {
        name: 'TouchA',
        pointerType: 'touch'
    },
    {
        name: 'TouchB',
        pointerType: 'touch'
    },
    {
        name: 'TouchC',
        pointerType: 'touch'
    }, 
];

exports.defaultKeyMap = defaultKeyMap;
